import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { taskActions, headerActions, fetchOpportunityById, referralActions, throwError, redirectToRoute } from '../../../actions';
import { HEADER } from '../../../constants';
import ContentLoader from 'components/common/loaders/ContentLoader';
import DataRow from '../DataRow';
import DateDivider from '../../appointments/DateDivider';
import _ from 'lodash';
import { getEmailRemainderOptions, getPushNotificationRemainderOptions, addressConcat } from 'helpers/utilities';

class TaskDetails extends React.Component {
  static propTypes = {
    fetchTask: PropTypes.func.isRequired,
    updateAgentTask: PropTypes.func.isRequired,
    setHeader: PropTypes.func.isRequired,
    fetchContact: PropTypes.func.isRequired,
    fetchOpportunity: PropTypes.func.isRequired,
    throwError: PropTypes.func.isRequired,
    redirectToRoute: PropTypes.func.isRequired,
    referralData: PropTypes.object,
    opportunityData: PropTypes.object,
    reminderPushNotificationFromTask: PropTypes.number,
    history: PropTypes.object,
    activeTask: PropTypes.object,
    remainderEmailFromTask: PropTypes.number,
    notesFromtask: PropTypes.string,
    opportunityType: PropTypes.string,
    contactId: PropTypes.string,
    opportunityId: PropTypes.number
  }

  state = {
    task: null,
    remainderMail: -1,
    notes: '',
    opportunityInfo: null,
    contactInfo: null,
    remainderPushNotification: -1
  }

  componentDidMount = async () => {
    try {
      this.props.setHeader({
        type: HEADER.UPDATE_HEADER,
        showHeader: true,
        headerTitle: 'Task Details',
        hasBackButton: true,
        backButtonIcon: 'close',
        hasNotificationIcon: true
      });

      const taskId = _.get(this.props, 'match.params.taskId', null);
      await this.props.fetchTask(taskId);
      const { contactId, opportunityId } = this.props;
      const fetchOpportunity = this.props.fetchOpportunity(contactId, opportunityId);
      const fetchContact = this.props.fetchContact(contactId);
      await Promise.all([fetchOpportunity, fetchContact]);

      this.setState((state, props) => ({
        task: props.activeTask,
        remainderMail: props.remainderEmailFromTask,
        notes: props.notesFromtask,
        contactInfo: props.referralData,
        opportunityInfo: props.opportunityData,
        remainderPushNotification: props.reminderPushNotificationFromTask
      }));
    } catch (err) {
      this.props.throwError('goback');
    }
  }

  onChangeAction = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  updateTask = () => {
    const routeTo = (this.props.history.length < 2) ? '/dashboard' : 'goback';
    const { remainderMail, remainderPushNotification, task } = this.state;
    const taskObj = {
      eventId: task.eventId,
      reminderMinutes: remainderMail,
      pushReminderMinutes: remainderPushNotification
    };
    this.props.updateAgentTask(task.eventId, taskObj, 'Task Updated!', 'Error Updating Task', routeTo);
  }

  completeTask = () => {
    const routeTo = (this.props.history.length < 2) ? '/dashboard' : 'goback';
    const taskObj = {
      eventId: this.state.task.eventId,
      isCompleted: true
    };
    this.props.updateAgentTask(this.state.task.eventId, taskObj, 'Task Completed!', 'Error Completing Task', routeTo);
  }

  redirectToReferralDetailsPage = () => {
    const contactId = _.get(this.state.task, 'contactId', null);
    this.props.redirectToRoute(`/referraldetails/${contactId}`);
  }

  render () {
    const { task, remainderMail, notes, opportunityInfo, contactInfo, remainderPushNotification } = this.state;
    const disableNotificationSave = ((parseInt(this.state.remainderPushNotification) === this.props.reminderPushNotificationFromTask));
    const disableEmailSave = ((parseInt(this.state.remainderMail) === parseInt(this.props.remainderEmailFromTask)));

    if (!(task && this.props.opportunityData && this.props.referralData)) {
      return (<ContentLoader isLoading />);
    }
    const opportunityType = this.props.opportunityType === 'Buyer' ? 'buying' : 'selling';
    const profileFullAddress = _.get(opportunityInfo, 'contactProperty.property.address', null);
    const profileSteetAddress = _.get(opportunityInfo, 'contactProperty.property.address.address1', null);
    const location = [];
    (opportunityInfo.areasOfInterest || []).map(address => {
      if (!address.type.includes('MLS') && location.length <= 0) {
        location.push(address.value);
      }
    });
    const ProfileCityStateZip = (location.length > 0) ? location : addressConcat(profileFullAddress || {});
    const opptaddresse = _.get(contactInfo, 'addresses', []);
    const contactAddress = addressConcat(opptaddresse[0] || {});
    const lineOneAddress = location.length > 0 ? null : profileSteetAddress;
    let lineTwoAddress = ProfileCityStateZip;
    if ((this.props.opportunityType === 'Seller') && (profileFullAddress == null) && location.length <= 0) {
      lineTwoAddress = contactAddress;
    }
    const imageUrl = _.get(opportunityInfo, 'contactProperty.property.imageUrl', null);

    return (
      <section className='page-content tasks-page task-detail-page'>
        <div className='task-container'>
          <div className='task-details-page'>
            <DateDivider date={task.startTime} />
            <DataRow task={task} shouldRedirect={false} showTaskStatus={false} />
            <div className='property-address' onClick={() => this.redirectToReferralDetailsPage()}>
              <div className={'d-flex'}>
                <div className='opportunity-icon'>
                  <span className={`lead-type-badge lead-${opportunityType}`} />
                </div>
                <div className='lead-type-wrapper'>
                  <div className='lead-type-text'>
                    {opportunityType.toUpperCase()}
                  </div>
                </div>
                <div className='lead-address'>
                  <div className='line-address'>{lineOneAddress}</div>
                  <div className='line-address'>{lineTwoAddress}</div>
                </div>
              </div>
              {
                imageUrl ? <div className={'property-image'}><img className={'show-image'} src={imageUrl} /></div> : null
              }
            </div>
            <div className='agent-note'>
              <div className='note-label'>
                <span className='note'>Description </span>
              </div>
              <div className='task-notes'>{notes}</div>
            </div>
            <div className='task-editable-section'>
              <div className='reminder-notification'>
                <div className='reminder'>Reminder Push Notification</div>
                <div className='select-status-custom'>
                  <select className='form-control' value={remainderPushNotification} onChange={this.onChangeAction} name='remainderPushNotification'>
                    {
                      getPushNotificationRemainderOptions().map((option, index) =>
                        <option key={index} value={option.value}>{option.text}</option>
                      )
                    }
                  </select>
                </div>
              </div>
              <div className='reminder-email'>
                <div className='reminder'>Reminder Email</div>
                <div className='select-status-custom'>
                  <select className='form-control' value={remainderMail} onChange={this.onChangeAction} name='remainderMail'>
                    {
                      getEmailRemainderOptions().map((option, index) =>
                        <option key={index} value={option.value}>{option.text}</option>
                      )
                    }
                  </select>
                </div>
              </div>
            </div>
            <div className='bottom-button-wrapper task-buttton-margin'>
              <div>
                <button className='task-primary-button'
                  onClick={() => this.completeTask()}
                  type='reset'>
                  Mark Complete
                </button>
              </div>
              <div className=' push'>
                <button
                  disabled={(disableEmailSave && disableNotificationSave)}
                  className='task-primary-button'
                  type='submit'
                  onClick={() => this.updateTask()}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => {
  const { referrals, tasks } = state;
  return {
    activeTask: _.get(tasks, 'activeTask', {}),
    referralData: _.get(referrals, 'referralData', null),
    opportunityData: _.get(referrals, 'opportunityData', null),
    contactInformation: _.get(referrals, 'referralData', null),
    contactId: _.get(tasks.activeTask, 'contactId', null),
    opportunityId: _.get(tasks.activeTask, 'opportunityId', null),
    remainderEmailFromTask: _.get(tasks.activeTask, 'reminderMinutes', -1),
    reminderPushNotificationFromTask: _.get(tasks.activeTask, 'pushReminderMinutes', -1),
    notesFromtask: _.get(tasks.activeTask, 'notes', ''),
    opportunityType: _.get(referrals, 'opportunityData.type', null),
    areasOfInterest: _.get(tasks.activeTask, 'areasOfInterest', [])
  };
};

const mapDispatchToProps = dispatch => ({
  fetchTask: bindActionCreators(taskActions.fetchTaskById, dispatch),
  updateAgentTask: bindActionCreators(taskActions.patchUpdateTask, dispatch),
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  fetchOpportunity: bindActionCreators(fetchOpportunityById, dispatch),
  fetchContact: bindActionCreators(referralActions.fetchContactData, dispatch),
  throwError: bindActionCreators(throwError, dispatch),
  redirectToRoute: bindActionCreators(redirectToRoute, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TaskDetails));
